import styled from 'styled-components'

const DeleteTime = styled('div')`
  padding: 5px 10px;
  opacity: 80%;
  display: flex;
`

export default DeleteTime
